import { useQuery } from "urql";
import { SponsorQuery, SponsorsQuery } from "../graphql/sponsors.graphql";

export interface Sponsor {
  sponsorId: string;
  name: string;
  description: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

const SPONSORS_FETCH_LIMIT = 10000;

export function useSponsors() {
  const [result, reexecute] = useQuery({
    query: SponsorsQuery,
    variables: { limit: SPONSORS_FETCH_LIMIT, offset: 0 },
  });

  return {
    sponsors: result.data?.sponsors.nodes ?? [],
    loading: result.fetching,
    error: result.error?.message ?? null,
    refetch: () => reexecute({ requestPolicy: "network-only" }),
  };
}

export function useSponsor(sponsorId: string | null) {
  const [result, reexecute] = useQuery({
    query: SponsorQuery,
    variables: { sponsorId: sponsorId ?? "" },
    pause: !sponsorId,
  });

  return {
    sponsor: result.data?.sponsor ?? null,
    loading: result.fetching,
    error: result.error?.message ?? null,
    refetch: () => reexecute({ requestPolicy: "network-only" }),
  };
}
